module.exports = __webpack_public_path__ + "static/media/3.59dc792d.jpg";